import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import {
  Button,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Divider,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

function toggleArrayItem(arr, item) {
  return arr.includes(item)
    ? arr.filter((i) => i !== item) // remove item
    : [...arr, item]; // add item
}

const ChecklistItem = ({ checked, name, display, onChange, isMobile }) => (
  <label
    htmlFor={name}
    className={cx('d-flex align-items-center filter-checklist-item pb-2', {
      'justify-content-between': isMobile,
    })}
    data-testid={`checklist-item-${name}`}
  >
    {isMobile ? (
      <>
        {display}
        <input
          type="checkbox"
          id={name}
          name={name}
          onChange={onChange}
          checked={checked}
          className="filter-checklist-input"
          data-testid={`checklist-input-${name}`}
        />
        <div className="filter-checkbox mr-2 d-flex align-items-center justify-content-center">
          <FontAwesomeIcon
            icon={faCheck}
            className="small filter-check-icon"
            data-testid={`check-icon-${name}`}
          />
        </div>
      </>
    ) : (
      <>
        <input
          type="checkbox"
          id={name}
          name={name}
          onChange={onChange}
          checked={checked}
          className="filter-checklist-input"
          data-testid={`checklist-input-${name}`}
        />
        <div className="filter-checkbox mr-2 d-flex align-items-center justify-content-center">
          <FontAwesomeIcon
            icon={faCheck}
            className="small filter-check-icon"
            data-testid={`check-icon-${name}`}
          />
        </div>
        {display}
      </>
    )}
  </label>
);

const FilterChecklist = ({
  activeOptions = [], // options from values specified in query params
  isMobile,
  onSave,
  filterOptions = [], // list of options including value name and display
}) => {
  // options currently selected in checklist (but not necessarily in query params)
  const [selectedOptions, setSelectedOptions] = React.useState(activeOptions);

  const handleSave = () => {
    onSave(selectedOptions);
  };

  const handleClear = () => {
    setSelectedOptions([]);
  };

  const handleChange = (e) => {
    const inputName = e.target.name;
    const newOption = filterOptions.find((option) => option.name === inputName);
    const newOptionsArray = toggleArrayItem(selectedOptions, newOption);
    setSelectedOptions(newOptionsArray);
  };

  return (
    <div className="filter-checklist">
      <div
        className="dropdown-items d-flex flex-column px-3 pt-2"
        data-testid="dropdown-items"
      >
        {filterOptions.map((option) => (
          <ChecklistItem
            name={option.name}
            display={option.display}
            key={option.name}
            onChange={handleChange}
            checked={selectedOptions.includes(option)}
            isMobile={isMobile}
          />
        ))}
      </div>
      <div className="filter-controls pb-2" data-testid="filter-controls">
        <DropdownItem divider className="mt-0" />
        <div className="d-flex justify-content-between px-3">
          <Button
            onClick={handleClear}
            disabled={selectedOptions.length === 0}
            color="link"
            size={isMobile ? undefined : 'sm'}
            className="px-0"
            data-testid="filter-clear-button"
          >
            <u>Clear</u>
          </Button>
          <Button
            onClick={handleSave}
            color="primary"
            size={isMobile ? undefined : 'sm'}
            data-testid="filter-save-button"
          >
            Save
          </Button>
        </div>
      </div>
    </div>
  );
};

FilterChecklist.propTypes = {
  activeOptions: PropTypes.array,
  isMobile: PropTypes.bool,
  onSave: PropTypes.func,
  filterOptions: PropTypes.array,
};

export default FilterChecklist;
